import { Dutch, English, French, German, Language, Polish, Portuguese, Spanish, Japanese} from './language';

export class Country {
  public static readonly US = new Country('US', 'United States', 'USD', [English]);
  public static readonly CA = new Country('CA', 'Canada', 'CAD', [English, French]);
  public static readonly GB = new Country('GB', 'United Kingdom', 'GBP', [English]);
  public static readonly IE = new Country('IE', 'Ireland', 'EUR', [English]);
  public static readonly AR = new Country('AR', 'Argentina', 'ARS', [Spanish, English]);
  public static readonly AT = new Country('AT', 'Austria', 'EUR', [German, English]);
  public static readonly DE = new Country('DE', 'Germany', 'EUR', [German, English]);
  public static readonly PL = new Country('PL', 'Poland', 'PLN', [Polish, English]);
  public static readonly BR = new Country('BR', 'Brazil', 'BRL', [Portuguese, English]);
  public static readonly NL = new Country('NL', 'Netherlands', 'EUR', [Dutch, English]);
  public static readonly JP = new Country('JP', 'Japan', 'JPY', [Japanese, English]);

  public static readonly ALL = [
    Country.AR,
    Country.AT, Country.DE,
    Country.GB, Country.IE,
    Country.US, Country.CA,
    Country.NL,
  ];

  private constructor(
    public readonly code: CountryCode,
    public readonly displayName: CountryName,
    public readonly currencyCode: CurrencyCode,
    public readonly languages: Language[],
    public readonly defaultLanguage = languages[0]
  ) {}
}

export const { US, CA, GB, IE, DE, AT, AR, BR, PL, NL } = Country;
